import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import ExportListComponent from "../components/exports/ExportListComponent";
import { triggerExportStatusList } from "../store/layouts/actions";
import { getAviList, setAviID } from "../store/recordings/actions";
import { ApplicationState } from "../store";
import { RecordingState } from "../store/recordings/types";


export const sortByNumber = (arr: any[], key: string, direction: number) => {
    const newArr = arr.slice(0);
    return newArr.sort((a, b) => direction === 1 ? b[key] - a[key] : a[key] - b[key])
};

export const sortByText = (arr: any[], key: string, direction: number) => {
    const newArr = arr.slice(0);
    return newArr.sort((a, b) => a[key] > b[key] ? direction * 1 : direction * (-1))
};


const ExportListContainer = () => {
    const dispatch = useDispatch();
    const { avilist } = useSelector<ApplicationState, RecordingState>(state => state.recording);
    
    const [sortParams, setSortParams] = useState({type: 'creation_time', direction: 1});
    const { type, direction } = sortParams;

    const closeHandler = () => dispatch(triggerExportStatusList());
    const shareStatusHandler = (aviId: string) => {
        dispatch(setAviID(aviId));
    };

    useEffect( () => {
        dispatch(getAviList());
        const interval = setInterval(() => {
            dispatch(getAviList())
        }, 1000);

        return () => clearInterval(interval)
    }, []);

    const setSorting = (newType: string) => {
        newType === type
            ? setSortParams({type, direction: -1 * direction})
            : setSortParams({type: newType, direction})
    };

    const sortedAvilist = () => {
        if (type === 'cam_name') return sortByText(avilist, 'cam_name', direction);
        if (type === 'start_time') return sortByNumber(avilist, 'start_time', direction);
        if (type === 'duration') return sortByText(avilist, 'duration', direction);
        if (type === 'size') return sortByNumber(avilist, 'size', direction);
        if (type === 'status') return sortByNumber(avilist, 'completion', direction);
        if (type === 'creation_time') return sortByNumber(avilist, 'creation_time', direction);
        return avilist
    };

    return (
        <ExportListComponent
            closeHandler={closeHandler}
            shareStatusHandler={shareStatusHandler}
            avilist={sortedAvilist()}
            direction={direction}
            setSorting={setSorting}
            type={type}
        />
    )
};


export default ExportListContainer